/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Contract type
 * @export
 */
export const ContractType = {
    INDIVIDUAL: 0,
    ALIMONY: 1,
    GROUP: 2
} as const;
export type ContractType = typeof ContractType[keyof typeof ContractType];


export function instanceOfContractType(value: any): boolean {
    for (const key in ContractType) {
        if (Object.prototype.hasOwnProperty.call(ContractType, key)) {
            if (ContractType[key as keyof typeof ContractType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContractTypeFromJSON(json: any): ContractType {
    return ContractTypeFromJSONTyped(json, false);
}

export function ContractTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractType {
    return json as ContractType;
}

export function ContractTypeToJSON(value?: ContractType | null): any {
    return value as any;
}

export function ContractTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ContractType {
    return value as ContractType;
}

